export default __webpack_public_path__ + "static/media/noun-outstanding.887f3066.svg";